import { filter } from "lodash";
import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import moment from 'moment';

import { useSelector } from "react-redux";

import { useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { retry } from "redux-saga/effects";
import { contractWriteResponse, contractWriteHistory, companyListCall, getContractedEmitter, getOutsourcingContracted, getContractedTreatment, getCarList, getCarListAll, insertCollect } from "../../crud/auth.crud"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// import images
import loading from "../../assets/images/loading.gif";

import Modal from "../../components/RopikCustom/Modal";
import Util from "pages/Dashboard/Common/Util";

import FileUploads from "../../components/RopikCustom/FileUploads";

const style = { backgroundColor: "#ffffff", padding: "0.5rem", cursor: "pointer", width: '466px', border: '1px solid #bdbdbd', marginTop : '0.5rem', borderRadius: '4px', color : '#333'  };

const hoverStyle = { backgroundColor: "#4DBBAA", color: "#ffffff", width: '466px', border: '1px solid #4DBBAA' };

const ContractWrite = () => {
  const selector = useSelector(state => state)

  const [imgArr, setImgArr] = useState([]);
  const [user, setUser] = useState(selector.auth?.user)
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.id);
  const [companyList, setCompanyList] = useState([]);
  const [onUpload, setOnUpload] = useState(false);
  const [previewImages, setPreviewImages] = useState([])
  const history = useHistory()
  const [treatmentList, setTreatmentList] = useState([])
  const [selectedCompany, setSelectedCompany] = useState('')
  const [selectedTreatment, setSelectedTreatment] = useState('')
  const [wasteCollect, setWasteCollect] = useState('')

  const [isHover, setIsHover] = useState(false); // 계약처 선택 시 마우스 호버 상태

  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);

  const isValiddate = () => {
    if (!selectedCompany) {
      return alert("업체를 선택해주세요")
    }
    if (!selectedTreatment) {
      return alert("처리장을 선택해주세요")
    }
    if (wasteCollect === '') {
      return alert("수거량을 입력해주세요.")
    }
    return "success"
  }

  const handleWrite = async () => {
    const isValid = isValiddate();
    if (isValid !== 'success') {
      return isValid
    }
    setOnUpload(true)

    try {
      const fd = new FormData();

      for (let i = 0; i < imgArr.length; i++) {
        let newFile = new File([imgArr[i]], `${encodeURI(imgArr[i].name)}`, {type: imgArr[i].type})
        fd.append('file_' + i, newFile);
      }

      const wasteCollectData = {
        'company' : selectedCompany.emitterCompany?.id,
        'memo' : '',
        'driver_company' : selectedCompany?.driverCompanyId,
        'destination_to_company' : selectedCompany?.driverCompanyId === companyId ? null : companyId,
        'is_destination' : selectedCompany?.driverCompanyId === companyId? 'N' : 'Y',
        'treatment' : selectedTreatment?.id,
        'member' : user?.id,
        'qty' : wasteCollect,
        'state' : 'Y',
      }
      fd.append('waste_collect_data', JSON.stringify(wasteCollectData))

      const response = await insertCollect(fd);
      if(response.data?.result === 'success'){
        history.push('/collect-history')
      }
      setOnUpload(false)

    } catch (e) {
      setOnUpload(false)
    }
  }

  const deleteImage = (index) => {    
    setImgArr(imgArr.filter((v, i) => { return i !== index;}))    
    setPreviewImages(previewImages.filter((v, i) => { return i !== index;}))
  }

  const handleFileChange = (event) => {
    const files = event.target.files;
    let prevTmp = [];
    for (let i = 0; i < files.length; i++) {
      let item = {
        name : files[i].name,
        path :  URL.createObjectURL(files[i]),        
      }
      prevTmp.push(item)
    }
    let tmp = [...imgArr, ...event.target.files];
    tmp = tmp.filter((v, i) => {return i - 5 < 0})    
    setImgArr(tmp)    
    prevTmp = prevTmp.filter((v, i) => {return i - 5 < 0})
    setPreviewImages(prevTmp);
  };

  const getCompanyList = async() => {
    const rs = await getContractedEmitter(companyId)
    const rsData = rs.data?.data || []
    let filtering1 = new Set();
    let tmp = []
    for(let i=0; i<rsData.length; i++){
      if(!filtering1.has(rsData[i].contract_company_group_data.id)){
        filtering1.add(rsData[i].contract_company_group_data.id)
        tmp.push({
          driverCompanyId : companyId,
          emitterCompany : rsData[i].contract_company_group_data
        })
      }
    }
    const rs2 = await getOutsourcingContracted(companyId)
    const rsData2 = rs2.data?.data || [];
    for(let i=0; i<rsData2.length; i++){                  
      for(let j=0; j < rsData2[i]?.destination_contract_data?.length; j++){   
        let itm ={
          driverCompanyId : rsData2[i].company_from,
          emitterCompany : rsData2[i].destination_contract_data[j]?.company
        }
        tmp.push(itm)
      }
    }
    setCompanyList(tmp)
  }

  const getTreatmentList = async() =>{
    const rs = await getContractedTreatment(companyId)
    const rsData = rs.data?.data || [];
    let filtering = new Set();
    let tmp = []
    for(let i = 0; i < rsData.length; i++){
      if(!filtering.has(rsData[i].contract_company_group_data.id)){
        filtering.add(rsData[i].contract_company_group_data.id)
        tmp.push(rsData[i])
      }
    }
    setTreatmentList(tmp)
  }

  const modalClose = () => {
    setModalShow(false)
  }

  const modalClose2 = () => {
    setModalShow2(false)
  }

  useEffect(()=>{
    getCompanyList()
    getTreatmentList()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>수거내역 등록 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Breadcrumbs maintitle="Home" title="수거내역" breadcrumbItem="수거내역 등록" />
            <Col sm={6}>
              <div className="float-end d-none d-md-block page-title-box">
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs="12" style={{maxWidth: '28rem'}}>
              {/* Render Email SideBar */}
              {/* <EmailSideBar /> */}
              <div className="email-rightbar mb-3">
                <Card>
                  <CardBody style={{ padding: 24 }}>
                    <div style={{ marginBottom: 24 }}>
                      <p style={{ width: 110, color: '#333', fontSize: 16, fontWeight: 600, lineHeight: "35px", marginBottom: 8 }}>배출업체명</p>
                      <div className="d-flex">
                        <input placeholder="배출업체를 선택해주세요" type="text" className="is-untouched is-pristine av-invalid form-control" disabled="disabled" style={{ width: 240 }} value={selectedCompany.emitterCompany?.name} />
                        <div className="waver-pagination-btn-group" >
                          <button className="waves-effect submit-btn btn btn-secondary margin-left-6 font-size-16"
                            onClick={() => {
                              setModalShow(true)
                            }}
                          >업체 선택</button>
                        </div>
                      </div>
                    </div>
                    <div style={{ marginBottom: 24 }}>
                      <p style={{ width: 110, color: '#333', fontSize: 16, fontWeight: 600, lineHeight: "35px", marginBottom: 8 }}>처리장명</p>
                      <div className="d-flex">
                        <input placeholder="처리장을 선택해주세요" type="text" className="is-untouched is-pristine av-invalid form-control" disabled="disabled" style={{ width: 240 }} value={selectedTreatment.name} />
                        <div className="waver-pagination-btn-group" >
                          <button className="waves-effect submit-btn btn btn-secondary margin-left-6 font-size-16"
                            onClick={() => {
                              setModalShow2(true)
                            }}
                          >처리장 선택</button>
                        </div>
                      </div>
                    </div>
                    <div style={{ marginBottom: 24 }}>
                      <p style={{ color: '#333', fontSize: 16, fontWeight: 600, lineHeight: "35px", marginBottom: 8 }}>수거량</p>
                      <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <input className="is-untouched is-pristine av-invalid form-control" placeholder="수거량을 입력해주세요" style={{ height: 38, textAlign: "right" }} value={wasteCollect === '' ? '' : Util.setPrice(wasteCollect)} onChange={(e) => {setWasteCollect(e.target.value.replace(/,/g, ''))}} />
                        <p style={{ lineHeight: '35px', marginBottom: 0 }}>&nbsp;L&nbsp;</p>
                      </div>
                    </div>
                    <FileUploads title={'사진 선택'} arr={previewImages} handleChange={handleFileChange} handleDelete={deleteImage} />
                    <div style={{textAlign: 'right'}}>
                    <Button
                      type="button"
                      color="silver"
                      style={{ padding: '0.4rem 1.75rem', borderRadius: '0.2rem', marginRight: 16 }}
                      onClick={() => { history.goBack() }}
                    >
                      목록으로
                    </Button>
                    <Button
                      type="button"
                      color="primary"
                      style={{ padding: '0.4rem 1.75rem', borderRadius: '0.2rem' }}
                      onClick={() => { handleWrite() }}
                    >
                      등록하기
                    </Button>
                    </div>
                  </CardBody>

                </Card>
              </div>
            </Col>
          </Row>
          <Modal title={'업체 선택'} show={modalShow} onHide={modalClose} size="md">
            <div style={{ zIndex: 1, minHeight : '300px' }}>                        
              <div style={{ position: "relative", minHeight : '300px', overflowY: "auto" }}>
                <div style={{position: "absolute", minHeight : '300px', right: 0, left: 0, overflowX: "hidden"}}>
                  {companyList && companyList.map((item) => {
                    return (
                      <div style={isHover == item.emitterCompany?.id ? { ...style, ...hoverStyle } : { ...style }} key={item.emitterCompany?.id}
                        onMouseOver={() => {
                          setIsHover(item.emitterCompany?.id)
                        }}
                        onMouseLeave={() => {
                          setIsHover(false)
                        }}
                        onClick={() => {
                          setSelectedCompany(item)
                          modalClose()
                        }}>{item.emitterCompany.name}
                      </div>
                    )
                  })}
                </div>
              </div>                          
            </div>
          </Modal>
          <Modal title={'처리장 선택'} show={modalShow2} onHide={modalClose2} size="md">
            <div style={{ zIndex: 1, minHeight : '300px' }}>
              <div style={{ position: "relative", minHeight : '300px', overflowY: "auto" }}>
                <div style={{position: "absolute", minHeight : '300px', right: 0, left: 0, overflowX: "hidden"}}>
                  {treatmentList && treatmentList.map((item) => {
                    return (
                      <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                        onMouseOver={() => {
                          setIsHover(item.id)
                        }}
                        onMouseLeave={() => {
                          setIsHover(false)
                        }}
                        onClick={() => {
                          setSelectedTreatment(item.contract_company_group_data)
                          modalClose2()
                        }}>{item.contract_company_group_data.name}
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </Modal>
          
        </Container>        
      </div>
      {onUpload && <div style={{
        position: "absolute",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0.6)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={loading} alt="로딩중입니다." width={'5%'}></img>
      </div>}
    </React.Fragment>
  )
}

export default ContractWrite
